import { Box, Typography } from '@mui/material';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import DashboardEmissionsTable from '../../../shared-components/DashboardEmissionsTable'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getCompanyEmissionsScopeTwo } from '../../../../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors';
import { scopeTwoEmissionColumns, scopeTwoTitle } from '../../../constants/dashboard-constants';


export default function ScopeTwoEmissionsOverview({ openAccordion, changeAccordion, companyName, companyId, year }) {
    const accordionName = 'Scope Two Emissions Overview'
    const dispatch = useDispatch()
    const scopeTwoEmissionData = useSelector((state) => (state.emissionFactorsReducer?.companyEmissionsScopeTwo?.data))
    const isLoading = useSelector((state) => (state.emissionFactorsReducer?.companyScopeTwoLoading))

    const columns = scopeTwoEmissionColumns(companyName)

    useEffect(() => {
        if (openAccordion === accordionName) {
            dispatch(getCompanyEmissionsScopeTwo(companyId, year))
        }
    }, [dispatch,
        openAccordion,
        companyId,
        year])

    return (
        <DataAccordion
            title={scopeTwoTitle}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 2 }}>
                <Typography variant='h6'>
                    Scope Two Emissions for {companyName} in {year}:
                </Typography>
                <DashboardEmissionsTable loading={isLoading} columns={columns} rows={scopeTwoEmissionData} />
            </Box>
        </DataAccordion>
    )
}